export default __webpack_public_path__ + "static/media/GlyGen-NIH-Common-Fund-2020.a4219917.pdf";